import { Button, Grid, Stack, Typography } from '@mui/material';
import type {} from '@mui/x-date-pickers/themeAugmentation';
import type {} from '@mui/x-charts/themeAugmentation';
import type {} from '@mui/x-tree-view/themeAugmentation';
import CameraAltIcon from '@mui/icons-material/CameraAlt';

import Copyright from '../internals/components/Copyright';
import ChartUserByCountry from '../components/ChartUserByCountry';
import CustomizedTreeView from '../components/CustomizedTreeView';
import CustomizedDataGrid from '../components/CustomizedDataGrid';
import HighlightedCard from '../components/HighlightedCard';
import PageViewsBarChart from '../components/PageViewsBarChart';
import SessionsChart from '../components/SessionsChart';
import StatCard, { type StatCardProps } from '../components/StatCard';
import PageBaseLayout from '../layouts/PageBaseLayout';

import ScanRefereeQr from '../components/ScanRefereeQr';
import useDialog from '../hooks/useDialog';
import { supabase } from '../supabase-client';
import { useEffect, useState } from 'react';
import useBackdrop from '../hooks/useBackdrop';
import useSnackbar from '../hooks/useSnackbar';
import {
  aggregateAffiliateLinksPerDay,
  calculateBalanceFromTransactions,
} from '../utils';
import Bugsnag from '@bugsnag/js';

export default function BrandDashboard() {
  const backdrop = useBackdrop();
  const dialog = useDialog();
  const snackbar = useSnackbar();
  const [balance, setBalance] = useState(0);
  const [affiliateLinks, setAffiliateLinks] = useState<any[]>([]);

  const data: StatCardProps[] = [
    {
      title: 'Balance',
      value: `$${balance.toFixed(2)}`,
      interval: '',
      trend: 'up',
    },
    {
      title: 'Affiliate Links',
      value: affiliateLinks.length.toString(),
      interval: 'Last 30 days',
      trend: 'down',
      data: affiliateLinks,
    },
    // {
    //   title: 'Event count',
    //   value: '200k',
    //   interval: 'Last 30 days',
    //   trend: 'neutral',
    //   data: [
    //     500, 400, 510, 530, 520, 600, 530, 520, 510, 730, 520, 510, 530, 620,
    //     510, 530, 520, 410, 530, 520, 610, 530, 520, 610, 530, 420, 510, 430,
    //     520, 510,
    //   ],
    // },
  ];

  const getData = async () => {
    backdrop.handleBackdropOpen();

    try {
      const balanceResponse = await supabase
        .schema('admin_backend')
        .from('brand_balances')
        .select('*')
        .single();

      if (balanceResponse.error) {
        console.error('Error fetching brand balance:', balanceResponse.error);
        throw balanceResponse.error;
      }

      const balance = balanceResponse.data.balance;
      setBalance(balance);

      const affiliateLinksResponse = await supabase
        .schema('app')
        .from('affiliate_links')
        .select('created_at');

      if (affiliateLinksResponse.error) {
        console.error(
          'Error fetching affiliate links:',
          affiliateLinksResponse.error,
        );
        throw affiliateLinksResponse.error;
      }

      const affiliateLinks = affiliateLinksResponse.data;

      setAffiliateLinks(affiliateLinks);
    } catch (error) {
      snackbar.handleSnackbarOpen('An error occurred.', 'error');
    }

    backdrop.handleBackdropClose();
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <PageBaseLayout
      title="Dashboard"
      actions={
        <>
          <Button
            startIcon={<CameraAltIcon />}
            onClick={async () => {
              dialog.handleDialogOpen(
                <ScanRefereeQr onRedeemed={getData} />,
                'QR Scan',
              );
              // dataCtx.handleSnackbarOpen('QR Scan initiated', 'info');
            }}>
            Scan QR
          </Button>
          {/* <Button
            startIcon={<CameraAltIcon />}
            onClick={async () => {
              snackbar.handleSnackbarOpen('another msg', 'info');
              // Bugsnag.notify(new Error('Test error'));
              throw new Error('some error3');
            }}>
            Snackbar xx
          </Button>
          <Button
            startIcon={<CameraAltIcon />}
            onClick={async () => {
              snackbar.handleSnackbarOpen('test', 'info');
            }}>
            Snackbar Open
          </Button> */}
        </>
      }>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}>
        {data.map((card) => (
          <Grid key={card.title} size={{ xs: 12, sm: 6, lg: 3 }}>
            <StatCard {...card} />
          </Grid>
        ))}
        {/* <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <HighlightedCard />
        </Grid> */}
        {/* <Grid size={{ xs: 12, md: 6 }}>
          <SessionsChart />
        </Grid> */}
        {/* <Grid size={{ xs: 12, md: 6 }}>
          <PageViewsBarChart />
        </Grid> */}
      </Grid>
      {/* <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Details
      </Typography>
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12, lg: 9 }}>
          <CustomizedDataGrid />
        </Grid>
        <Grid size={{ xs: 12, lg: 3 }}>
          <Stack gap={2} direction={{ xs: 'column', sm: 'row', lg: 'column' }}>
            <CustomizedTreeView />
            <ChartUserByCountry />
          </Stack>
        </Grid>
      </Grid> */}
      <Copyright sx={{ my: 4 }} />
    </PageBaseLayout>
  );
}
